import React from 'react';
import TenantManager from './../../components/tenantManager';
import tenants from './tenants';

import './user.css';

class UserPage extends React.Component {
    render() {
        const { match } = this.props;
        if (!match || !match.params) return null;

        const { refId, refType, userId } = match.params;
        if (!refId || !refType || !userId) return null;

        return (
            <div className="page">
                <TenantManager {...tenants} {...match.params} />
            </div>
        );
    }
}

UserPage.meta = {
    hide: true,
    locations: ['/user/']
};

export default UserPage;



// WEBPACK FOOTER //
// ./src/pages/user/index.jsx